import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Toaster from "../../Components/Toaster";
import { Box, Stack, Container, Button, Typography } from "@mui/material";
import OTPInput from "react-otp-input";
import VerifiedIcon from "@mui/icons-material/Verified";
import AutorenewSharpIcon from "@mui/icons-material/AutorenewSharp";
import {
  otpVerification,
  vendorRegistration,
  forgotPasswordOtpVerification,
  forgetPasswordVendorCode,
} from "../../../serviceFile/ApiService";

const OtpVerification = () => {
  const [otpErr, setOtpErr] = useState(""); // state used to maintain errors
  const [otp, setOtp] = useState(); // state used for store vendor code
  const [resendOtpCount, setResendOtpCount] = useState(0);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const Vcode = localStorage.getItem("vendorCode");
  const isForgetPassword = searchParams.get("isForgotpassword");

  // otp submission function
  const handleSubmit = () => {
    if (otp?.length === 0) {
      setOtpErr("Please enter OTP");
      return;
    }
    if (otp?.length < 6) {
      setOtpErr("Please enter the full code");
      return;
    }
    if (otpErr !== "") {
      return;
    } else if (isForgetPassword) {
      forgotPasswordOtpVerification(otp, Vcode)
        .then((res) => {
          const errorMessage = res?.data?.message;
          if (res?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("OTP verified successfully", 12, ["success"]);
            navigate(`/Registration/ChangePassword?isForgetPassword=${true}`, {
              replace: true,
            });
            const token = res?.data?.token;
            localStorage.setItem("token", token);
          }
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message;
          if (err?.response?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("Sorry something went wrong!", 134, ["error"]);
          }
        });
    } else {
      otpVerification(otp, Vcode)
        .then((res) => {
          const errorMessage = res?.data?.message;
          if (res?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("OTP verified successfully", 12, ["success"]);
            navigate("/Registration/ChangePassword", { replace: true });
            const token = res?.data?.token;
            localStorage.setItem("token", token);
          }
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message;
          if (err?.response?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("Sorry something went wrong!", 134, ["error"]);
          }
        });
    }
  };

  // function to handle vendor code validations
  const handleOtp = (e) => {
    const otpVal = e;
    setOtp(otpVal);
    if (otpVal === null || otpVal === "") setOtpErr("Please enter OTP");
    else if (otpVal?.length === 0) {
      setOtpErr("Please enter OTP");
    } else {
      setOtpErr("");
      setOtp(otpVal);
    }
  };

  // function to handle resend otp
  const handleResendOtp = () => {
    setResendOtpCount(resendOtpCount + 1);
    if (isForgetPassword) {
      forgetPasswordVendorCode(Vcode)
        .then((res) => {
          localStorage.setItem("vendorCode", Vcode);
          const message = res?.data?.message;
          if (message === "Already Registered") {
            Toaster("You have already registered!", 101, ["warning"]);
          } else if (res?.data?.status === 404) {
            Toaster(message, 109, ["error"]);
          } else {
            Toaster("OTP sent successfully", 101, ["success"]);
            navigate(`/Registration/OtpVerification?isForgotpassword=${true}`, {
              replace: true,
            });
          }
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message;
          if (err?.response?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("Sorry something went wrong!", 134, ["error"]);
          }
        });
    } else {
      vendorRegistration(Vcode)
        .then((res) => {
          const errorMessage = res?.data?.message;
          if (res?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("OTP sent successfully", 12, ["success"]);
          }
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message;
          if (err?.response?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("Sorry something went wrong!", 134, ["error"]);
          }
        });
    }
  };
  return (
    <Container
      sx={{
        height: "80%",
        borderRadius: "10px",
        display: "flex",
        marginTop: "10px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Stack
          spacing={2}
          sx={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src="/assets/images/verifyLogo.png"
            alt="Verification logo"
            width="187"
            height="120"
          ></img>
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "darkslategray",
              fontWeight: 600,
              textTransform: "uppercase",
            }}
          >
            Enter OTP code
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: "darkslategray",
              fontSize: "14px",
              textOrientation: "sideways",
            }}
          >
            A one-time password (OTP) has been sent to <br /> your registered
            mobile number and email address.
          </Typography>
          <Stack spacing={2}>
            <OTPInput
              value={otp}
              numInputs={6}
              onChange={handleOtp}
              renderInput={(props) => (
                <input
                  {...props}
                  style={{
                    width: "40px",
                    height: "40px",
                    fontSize: "18px",
                    textAlign: "center",
                    margin: "0 5px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                />
              )}
            />
            {otpErr && (
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSizeize: "0.75rem",
                  lineHeight: 1.66,
                  letterspacing: "0.03333em",
                  textAlign: "left",
                  marginLight: "140px",
                  marginBottom: 0,
                }}
                color="#d32f2f"
                variant="body2"
              >
                {otpErr}
              </Typography>
            )}
            <Stack
              spacing={1}
              direction="row"
              justifyContent="end"
              sx={{ width: "100%" }}
            >
              <Button
                type="submit"
                variant="contained"
                alignItems="center"
                justifyContent="center"
                onClick={handleSubmit}
                endIcon={<VerifiedIcon />}
                sx={{
                  width: "50%",
                  height: 35,
                  backgroundColor: "darkgreen",
                  "&:hover": {
                    backgroundColor: "green", // Change this to the color you want on hover
                  },
                  backgroundSize: "200",
                  color: "white",
                  boxShadow: "0 0 20px rgb(255, 255, 255)",
                  borderRadius: "5px",
                  fontWeight: "bold",
                  fontSize: "13px",
                }}
              >
                Verify OTP
              </Button>
              <Button
                type="submit"
                variant="contained"
                alignItems="center"
                justifyContent="center"
                onClick={handleResendOtp}
                endIcon={<AutorenewSharpIcon />}
                sx={{
                  width: "50%",
                  height: 35,
                  backgroundColor: "goldenrod",
                  "&:hover": {
                    backgroundColor: "orange",
                  },
                  backgroundSize: "200",
                  color: "white",
                  boxShadow: "0 0 20px rgb(255, 255, 255)",
                  borderRadius: "5px",
                  fontWeight: "bold",
                  fontSize: "13px",
                }}
                disabled={resendOtpCount >= 3}
              >
                Resend OTP
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
};

export default OtpVerification;
